export default "__VITE_ASSET__eTDOkBgg__"